import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  MdPhotoLibrary,
  MdVideoLibrary,
  MdSentimentVerySatisfied,
} from 'react-icons/md';
import './CreateHaes.css';

const CreateHaes = ({ image }) => {
  const [isFocused, setIsFocused] = useState(undefined);
  const [title, setTitle] = useState('');

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };
  return (
    <form className="createhaes">
      <div className="createhaes__input">
        <div className="image">
          <img src={image} alt="User" />
        </div>
        <textarea
          //   className={
          //     isFocused ? 'createhaes__text--focused' : 'createhaes__text'
          //   }
          className="createhaes__text"
          name="title"
          value={title}
          focus={isFocused}
          onFocus={handleFocus}
          onChange={handleTitleChange}
          placeholder="Got an idea, Tolulope?"
          id="title"
          cols="30"
          rows="10"
          wrap="hard"
        />
      </div>
      <div className="createhaes__buttons">
        <div className="createhaes__item">
          <MdPhotoLibrary size={20} />
          <p>Photo</p>
        </div>
        <div className="createhaes__item">
          <MdVideoLibrary size={20} />
          <p>Video</p>
        </div>
        <div className="createhaes__item">
          <MdSentimentVerySatisfied size={20} />
          <p>Emoji</p>
        </div>
        <button className="btn btn--primary" type="button">
          Haes
        </button>
      </div>
    </form>
  );
};

CreateHaes.propTypes = {
  image: PropTypes.string,
};

CreateHaes.defaultProps = {
  image:
    'https://i0.wp.com/www.repol.copl.ulaval.ca/wp-content/uploads/2019/01/default-user-icon.jpg',
};

export default CreateHaes;
